import React, { useState } from 'react';
import {
  Container, Row, Col, Button, Form
} from 'react-bootstrap';
import Header from '../Header';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { School } from '../../Services/School';
import ActionButton from '../ActionButton';
import { staticData } from '../../helpers/data';
import PrivacyModal from '../common/PrivacyModal';
import { formatDate } from '../../helpers/utils';
import { sanitize, validateFormFields } from '../../utils/validationUtils';

function TutorSignupStepThree({ nextStep, prevStep, handleFormData, handleSchool, values }) {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [error2, setError2] = useState({});
  const [isChecked, setIsChecked] = useState(false);

  const validateForm = () => {
    const sanitizedData = {
      ...Object.keys(values).reduce((acc, key) => {
        acc[key] = sanitize(values[key]);
        return acc;
      }, {}),
      accept_privacy_policy: isChecked
    };

    const errors = validateFormFields(sanitizedData, 'tutor');
    setError2(errors);

    if (Object.keys(errors).length > 0) {
      NotificationManager.error(Object.values(errors)[0], 'Form Error', 3000);
      return false;
    }

    return true;
  };

  const submitFormData = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (values.email !== '') {
      School.sendEmail({ email: values.email, in_register: true }).then(
        (data) => {
          if (data.error === 0) {
            NotificationManager.success(data.message, 'success!', 2000);
            nextStep();
          }
        },
        (error) => {
          NotificationManager.error(error.toString(), 'Error!', 2000);
        }
      );
    } else {
      NotificationManager.error('Email is required', 'Error!', 2000);
    }
  };

  const handleCheckbox = (e) => {
    handleSchool(e.target.name, e.target.checked);
    setIsChecked(e.target.checked);
  };

  return (
    <>
      <Header />
      <section className="login-body" style={{ backgroundImage: 'url(\"images/signup-bg.jpg\")' }}>
        <Container>
          <Row>
            <Col md={12}>
              <div className="step-progress">
                <div className="step-progress-bar">
                  <div className="step-progress-percent" style={{ width: '50%' }}></div>
                </div>
                <div className="step-progress-text">
                  <h6>Profile Creation & Privacy Notice</h6>
                  <h6>50% Completed</h6>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={9}>
              <div className="signup-box">
                <div className="signup-left">
                  <h4>{staticData?.verbiage?.tutor[3]?.heading}</h4>
                  <p>{staticData?.verbiage?.tutor[3]?.text}</p>
                  <div className="signup-step" style={{ marginTop: 260 }}>
                    <ul>
                      <li></li><li></li><li className="active"></li><li></li><li></li><li></li>
                    </ul>
                  </div>
                </div>
                <div className="signup-right">
                  <Form onSubmit={submitFormData}>
                    <div className="add-details">
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" onChange={handleFormData("first_name")} defaultValue={values.first_name} placeholder="First Name*" />
                            <span className="err">{error2?.first_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" onChange={handleFormData("last_name")} defaultValue={values.last_name} placeholder="Last Name*" />
                            <span className="err">{error2?.last_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="tel" onChange={handleFormData("phone")} defaultValue={values.phone} placeholder="School/Company Main Phone Number" />
                            <span className="err">{error2?.phone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Select name="timezone" onChange={handleFormData("timezone")} defaultValue={values.timezone}>
                              <option disabled value=''>Select Time Zone*</option>
                              <option value="EST">EST</option>
                              <option value="CST">CST</option>
                              <option value="PST">PST</option>
                            </Form.Select>
                            <span className="err">{error2?.timezone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="email" onChange={handleFormData("email")} defaultValue={values.email} placeholder="Your School/Company Email Address" />
                            <span className="err">{error2?.email}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Select onChange={handleFormData("highest_education_background")} defaultValue={values.highest_education_background}>
                              <option disabled value=''>Highest Educational Background*</option>
                              <option value='NO-DEGREE'>NO DEGREE</option>
                              <option value='K-12'>K-12</option>
                              <option value="UG">UG</option>
                              <option value="PG">PG</option>
                              <option value="PHD">PHD</option>
                            </Form.Select>
                            <span className="err">{error2?.highest_education_background}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control as="textarea" rows={5} onChange={handleFormData("about")} defaultValue={values.about} placeholder="Tell us about yourself:
• What experience or expertise do you have?
• Do you have any certifications or awards?" />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <h6 className="text-muted">Privacy notice</h6>
                          <p className="text-muted">
                            <Button variant="link" className='text-primary' onClick={() => setShowPrivacyModal(true)}>Click here to read Privacy notice</Button>
                          </p>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="iagree mb-3" controlId="formBasicCheckbox">
                            <Form.Check className="text-grey" type="checkbox" name="accept_privacy_policy" checked={isChecked} onChange={handleCheckbox} label={`I have read & accepted the Privacy Notice as on ${formatDate()}`} />
                            <span className="err">{error2?.accept_privacy_policy}</span>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                    <div className="signup-back-btn">
                      <Link onClick={prevStep} to="#" className="btn btn-link">Back</Link>
                      <ActionButton
                        type='submit'
                        className='btn btn-primary btn-pill px-4'
                        title='Create Account'
                        requiredFields={[
                          values?.first_name,
                          values?.last_name,
                          values?.email,
                          values?.phone,
                          values?.timezone,
                          values?.highest_education_background,
                          isChecked ? 'true' : null
                        ]}
                      />
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
      <PrivacyModal
        show={showPrivacyModal}
        privacyText={staticData?.privacyText?.admin}
        handleClose={() => setShowPrivacyModal(false)}
      />
    </>
  );
}

export default TutorSignupStepThree;